import React from "react";

type UnderlineButtonProps = {
  label: string;
  onClick?: () => void;
  className?: string;
};

export default function UnderlineButton(props: UnderlineButtonProps) {
  return (
    <div
      className={`underline text-h2 cursor-pointer ${props.className || ""}`}
      onClick={props.onClick}
    >
      {props.label}
      <div className="underline"></div>
    </div>
  );
}
